import { sizes } from '@bugbug/core/theme/media';
import { useMedia } from 'react-use';

import type { Breakpoint } from '@bugbug/core/theme/media';

const useBreakpoint = (breakpoint: Breakpoint) => useMedia(`(min-width: ${sizes[breakpoint]}px)`);

export default useBreakpoint;
